import {Injectable} from '@angular/core';
import {User} from '../../classes/user.class';
import {Utils} from '../../utils.class';
import {ApiService} from '../api/api.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(protected apiService: ApiService,) {
        // super();
    }

    public saveUser(user: User) {
        return this.apiService.postCall$<User>('users', user);
    }

    public getList() {
        return this.apiService.getCallData$<User[]>(`users`);
    }

    public getUser(id: number) {
        return this.apiService.getCallData$<User>(`users/${id}`);
    }

    public deleteUser(userId: number): Promise<object> {
        return this.apiService.deleteCall(`users/${userId}`);
    }
}
